import { gql, useQuery } from "@apollo/client";

export const Me = gql`
	query Me {
		me {
			email
			roles
			name
		}
	}
`;
